export const MOD_BROWSE_ROUTE = 'mod-browse-list'
export const MOD_VIEW_ROUTE = 'mod-view'
export const LIBRARY_ROUTE = 'library'
export const LOCALISATION_ROUTE = 'localisation'
export const FOUROHFOUR_ROUTE = 'FourOhFour'

// USERS
export const USER_GUIDE_BROWSE_ROUTE = 'user-guides'
export const USER_MOD_BROWSE_ROUTE = 'user-mods'
export const USER_ROUTE = 'user'

// GUIDES
export const GUIDE_BROWSE_ROUTE = 'guide-browse-list'
export const GUIDE_VIEW_ROUTE = 'guide-view-route'
